/******/ (() => { // webpackBootstrap
/*!******************************!*\
  !*** ./js/sections/audio.js ***!
  \******************************/
(function () {
  function initAudioPlayer(playerId, audioId) {
    var audio = document.getElementById(audioId);
    if (!audio) return;
    var playBtn = document.querySelector('.custom-audio-player-' + playerId + ' .play-pause-btn');
    var timeDisplay = document.querySelector('.custom-audio-player-' + playerId + ' .time-display');
    var durationDisplay = document.querySelector('.custom-audio-player-' + playerId + ' .duration-display');
    var progressBar = document.querySelector('.custom-audio-player-' + playerId + ' .progress-container .progress-bar');
    var progressContainer = document.querySelector('.custom-audio-player-' + playerId + ' .progress-container');
    var volumeIcon = document.querySelector('.custom-audio-player-' + playerId + ' .volume-icon');
    var volumeSlider = document.querySelector('.custom-audio-player-' + playerId + ' .volume-slider');
    var volumeBar = document.querySelector('.custom-audio-player-' + playerId + ' .volume-bar');
    if (!playBtn || !timeDisplay || !durationDisplay || !progressBar || !progressContainer) return;
    function formatTime(seconds) {
      var mins = Math.floor(seconds / 60);
      var secs = Math.floor(seconds % 60);
      return (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '') + secs;
    }
    function updateTime() {
      if (audio.duration) {
        timeDisplay.textContent = formatTime(audio.currentTime);
        progressBar.style.width = audio.currentTime / audio.duration * 100 + '%';
      }
    }
    function updateDuration() {
      if (audio.duration) {
        durationDisplay.textContent = formatTime(audio.duration);
      }
    }
    playBtn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
        playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"><rect x="6" y="4" width="4" height="16" fill="#fff"/><rect x="14" y="4" width="4" height="16" fill="#fff"/></svg>';
      } else {
        audio.pause();
        playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"><polygon points="5 3 19 12 5 21" fill="none"/></svg>';
      }
    });
    progressContainer.addEventListener('click', function (e) {
      if (audio.duration) {
        var rect = progressContainer.getBoundingClientRect();
        audio.currentTime = (e.clientX - rect.left) / rect.width * audio.duration;
      }
    });
    if (volumeSlider && volumeBar) {
      volumeSlider.addEventListener('click', function (e) {
        var rect = volumeSlider.getBoundingClientRect();
        audio.volume = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        volumeBar.style.width = audio.volume * 100 + '%';
      });
    }
    if (volumeIcon && volumeBar) {
      volumeIcon.addEventListener('click', function () {
        if (audio.volume > 0) {
          audio.volume = 0;
          volumeBar.style.width = '0%';
          volumeIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
        } else {
          audio.volume = 1;
          volumeBar.style.width = '100%';
          volumeIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
        }
      });
    }
    audio.addEventListener('loadedmetadata', updateDuration);
    audio.addEventListener('timeupdate', updateTime);
    audio.volume = 1;
  }
  function initializePlayers() {
    document.querySelectorAll('[data-audio-player]').forEach(function (player) {
      var playerId = player.getAttribute('data-player-id');
      var audioId = player.getAttribute('data-audio-id');
      if (playerId && audioId) initAudioPlayer(playerId, audioId);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePlayers);
  } else {
    initializePlayers();
  }
})();
/******/ })()
;